import React, { Fragment } from 'react';
import {
    Box,
    Card,
    CardContent,
    CardHeader,
    Divider,
    Typography,
    Theme,
    Fade,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { TMaintenancePackageDetails } from 'src/interfaces/maintenancePackage';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
    },
}));

/**
 * Will return the list of details of the maintenance package
 *
 * @return {*}
 */
export const MaintenancePackageDetailsCard = ({
    details,
}: {
    details: TMaintenancePackageDetails[];
}) => {
    const { t } = useTranslation();
    const classes = useStyles();

    return (
        <Fade in={details.length > 0} timeout={600}>
            <Card elevation={0}>
                <CardHeader title={t('maintenancePackage.Details')} />
                <Divider />
                <CardContent className={classes.container}>
                    {details.map((detail, index) => (
                        <Box key={index}>
                            <Typography variant="h5">{detail.title}</Typography>
                            <Typography variant="body2">
                                {detail.description}
                            </Typography>
                        </Box>
                    ))}
                </CardContent>
            </Card>
        </Fade>
    );
};
